export { default, getOptsByCloudProviderByDeployment } from './useProviderRegions';
